import { entryPointConfig } from './entry-point-config';
import { type Config } from './types';

export function useEntryPointConfig(): Config {
	return entryPointConfig;
}
